import { useState } from 'react';
import { isDateToday } from '../../../../../utils/dateAndTime';

export const useDeliveryDateTimeState = () => {
  const [selectedDate, setSelectedDate] = useState<Date | undefined>(
    new Date(),
  );
  const [selectedTimeId, setSelectedTimeId] = useState<string | undefined>(
    undefined,
  );

  const isToday = isDateToday(selectedDate);

  return {
    selectedDate,
    selectedTimeId,
    isToday,
    setSelectedDate,
    setSelectedTimeId,
  };
};
